import { api } from "./api";

const OverviewService = {

  async checkDataSync() {
    const response = await api.get('/data/check');
    // console.log("getinfo",response.data)
    return response?.data;
  },


};

export default OverviewService;